<div
  class="card theme-text-color theme-bg-color"
  (click)="navigateToDetails()"
>
  <div class="card-wrapper" class="priority-{{ task.priority | lowercase }}">
    <div class="card-priority"></div>
    <dx-button
      icon="edit"
      stylingMode="text"
      (onClick)="notify($event)"
    ></dx-button>
    <div class="card-content">
      <div class="card-subject theme-text-color">{{ task.text }}</div>
      <div class="card-data">
        <span class="priority">{{ task.priority }}</span>
        <span class="date theme-text-color">{{
          task.dueDate | date: 'MM/dd/yyyy'
        }}</span>
      </div>
      <div class="card-assignee">
        <span class="company dx-theme-text-color">{{ task.company }}</span>
        <user-avatar [dataLetters]="getAvatarText(task.owner)"></user-avatar>
      </div>
    </div>
  </div>
</div>
